module.exports = __webpack_public_path__ + "static/blog-splash-3-b39c046de9b988a0d53224bdd5ef3dce.jpg";